import { render } from "./NotePlain.vue?vue&type=template&id=340b83fc&scoped=true"
import script from "./NotePlain.vue?vue&type=script&lang=js"
export * from "./NotePlain.vue?vue&type=script&lang=js"

import "./NotePlain.vue?vue&type=style&index=0&id=340b83fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340b83fc"]])

export default __exports__